import { render, staticRenderFns } from "./ReverseArrow.vue?vue&type=template&id=c2c92ad0&"
import script from "./ReverseArrow.vue?vue&type=script&lang=js&"
export * from "./ReverseArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports